<template>
  <div>
    <Menu />
    <div class="container main">
      <div class="row">
        <div class="col-md-12">
          <SectionTitle
            title="Resultado Indicadores Qualidade"
            description="Classificação por equipe nos Indicadores APS."
            url="/indicadores-aps"
            :enabledModalInformacao="true"
            :enabledIframeModalInformacao="true"
            urlIframeModalInformacao="https://doc.clickup.com/9011510980/d/h/8cj1fp4-1631/599ea88448ce3d9/8cj1fp4-3651"
            pageIdentifier="indicadores-aps-resultado-municipal"
            :enableBadgeModalInformacao="
              Number(
                $store.state.permissoesRaw
                  ?.resultado_municipal_indicadores_aps_ajuda || 0
              ) > 0
            "
            :badgeValueModalInformacao="
              $store.state.permissoesRaw
                ?.resultado_municipal_indicadores_aps_ajuda || 0
            "
            keyAjudaModalInformacao="resultado_municipal_indicadores_aps_ajuda"
          />
        </div>
      </div>
      <router-view></router-view>
    </div>
    <Footer />
  </div>
</template>

<script>
import Menu from '@/components/Menu'
import Footer from '@/components/Footer'
import SectionTitle from '@/components/SectionTitle'

export default {
  components: {
    Menu,
    Footer,
    SectionTitle,
  },
  metaInfo: {
    title: 'Indicadores APS - Resultado Municipal',
    titleTemplate: null,
  },
  data() {
    return {}
  },
}
</script>

<style></style>
